module.exports = __webpack_public_path__ + "static/media/Roboto-LightItalic.2ffc058d.ttf";